/* global globalThis */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PopupTypes } from '../../../components/Popup';
import { T } from '../../../components/Translations';
import { ApiUrl, AppPages } from '../../../project/Defines';
import { Project } from '../../../project/Project';
import { EVENT_NAME } from '../../../project/utilities';
import ListView from '../../../Shared/ListView';
import { COLUMN_FORMAT, COLUMN_TYPE } from '../../../Shared/ListView/helper';
import { openPopup } from '../../../store/actions';
import { hasValidCallData, isDocumentReadOnly, isDocumentReadOnlyForFeesAndSpareParts, skipDocumenConfirmingActions, useConfirmActions } from '../commonFunctions';

const listUpdateEvent = EVENT_NAME.DPC_LIST_UPDATE;
/**
 * @exports DPC
 */
function DPC(props) {
    const { disabled, dataItem, openPopup } = props;
    const isServiceCallTabMode = !!dataItem;
    const [staticFilter] = useState(isServiceCallTabMode ? { call_id: dataItem?.call_id || '' } : { confirmed: false });
    const [dpcCount, setDpcCount] = useState(null);

    const [detailProps] = useState({
        newTitle: 'text.create_new_dpc',
        editTitle: 'text.edit_dpc',
        fullScreen: false,
        popupType: PopupTypes.DPCDetail,
        windowKey: 'wndDPCDetails',
        newData: isServiceCallTabMode && { data: { callData: dataItem } }
    });

    const [isMobile, setIsMobile] = useState(globalThis.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
          setIsMobile(globalThis.innerWidth <= 768);
        };
        
        globalThis.addEventListener('resize', handleResize);
        return () => globalThis.removeEventListener('resize', handleResize);
    }, []);

    const { onConfirm, onReject } = useConfirmActions({ openPopup, listUpdateEvent, type: "RR", docType: "DPC" });

    const columns = [
        {
            text: 'text.request_id',
            noSort: 'true',
            field: 'DocNum',
            fixed: 'left',
            width: 80,
            type: COLUMN_TYPE.TEXT
        },
        {
            skip: isServiceCallTabMode,
            text: 'text.call_id',
            render: (text, record) => {
                return <wrap>
                    {(record.callData && <Link to={Project.getPageUrl(AppPages.ServiceCallsDetails, record.callData.ID)} style={{ color: "var(--main-color)" }}>
                        <text>{record.SCOrigin}</text>
                    </Link>) || <text>{record.SCOrigin}</text>}
                </wrap>;
            },
            noSort: 'true',
            field: 'SCOrigin',
            width: 100,
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.subcontractor',
            // noSort: 'true',
            field: 'subcontractor_name',
            width: (isMobile ? 240 : 270),
            render: (text, record) => {
                return <wrap>
                    { record.callData && <text>{record.callData.subcontractor_name}</text> }
                </wrap>
            },
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.date',
            noSort: 'true',
            field: 'DocDate',
            type: COLUMN_TYPE.TEXT,
            width: 100,
            format: COLUMN_FORMAT.DATE
        },
        {
            text: 'text.total',
            noSort: 'true',
            field: 'DocTotal',
            width: 100,
            type: COLUMN_TYPE.TEXT
        },
        {
            text: 'text.status',
            noSort: 'true',
            field: 'DocStatus',
            width: (isMobile ? "140" : 120),
            type: COLUMN_TYPE.TEXT,
            render: (text, record) => {
                return (
                    <wrap>
                        <group> <text>{text}</text>
                            {record.IsChangeRequested && <badge l_space="" outline=""
                            ><T>text.change_requested</T></badge>}
                        </group>
                    </wrap>
                );
            },
        },
        {
            text: 'text.type_of_exchange_doc',
            noSort: 'true',
            width: 100,
            field: 'ReturnType',
            type: COLUMN_TYPE.TEXT
        },
        {
            skip: !isServiceCallTabMode,
            text: 'text.confirmed',
            noSort: 'true',
            field: 'Confirmed',
            width: 100,
            type: COLUMN_TYPE.TEXT
        },
        // hasValidCallData("axax") && 
        {
            type: COLUMN_TYPE.ACTION,
            width: (isMobile ? "" : 100),
            fixed: 'right',
            commands: [
                { command: 'edit', skipCommandForRecord: record => (!hasValidCallData(record) || isDocumentReadOnly(record)) },
                { command: 'edit', icon: 'eye', key: 'view', skipCommandForRecord: record => (!hasValidCallData(record) || !isDocumentReadOnly(record)) },
                { command: 'done', skipCommandForRecord: skipDocumenConfirmingActions, onClick: onConfirm, tooltip: 'text.approve' },
                { command: 'close', skipCommandForRecord: skipDocumenConfirmingActions, onClick: onReject, tooltip: 'text.reject' }
            ]

        }
    ].filter(col => !col.skip);
    // const allowNew = isServiceCallTabMode && !isDocumentReadOnly({ callData: dataItem }) && dpcCount === 0;
    const readOnly = isServiceCallTabMode && !isDocumentReadOnlyForFeesAndSpareParts({ callData: dataItem }) && dpcCount !== 0;
    const hasValidStatusID = dataItem?.status_id === '-3' || dataItem?.status_id === '1' || dataItem?.status_id === '27';
    
    return (
        <ListView
            {...props}
            // className='visible_buttons'
            className={`scroll_fix ${isMobile ? "visible_buttons" : ""}`}
            columnConfig={columns}
            staticFilter={staticFilter}
            apiUrl={ApiUrl.DPCList}
            noPaging
            keyField='DocNum'
            listUpdateEvent={listUpdateEvent}
            detailProps={detailProps}
            isSimple
            onLoaded={isServiceCallTabMode ? data => {
                data && setDpcCount(data.length);
                return data;
            } : null}
            onDoubleClick={(record, rowIndex, event, onEdit) => { !disabled && hasValidCallData(record) && !isDocumentReadOnly(record) && onEdit(record, rowIndex, event); }}
            // skipNewButton={disabled || !allowNew}
            skipNewButton={disabled || !isServiceCallTabMode || readOnly || !hasValidStatusID}
        />
    );
}

DPC.propTypes = {
    disabled: PropTypes.bool,
    dataItem: PropTypes.object,
    openPopup: PropTypes.func.isRequired
};

export default connect(null, dispatch => ({ openPopup: props => dispatch(openPopup(props)) }))(DPC);
